import { getCipInfo, cipLogin, getCipNetworkDetail, getCipFlushQrcode } from 'services';
import { getUrlParam } from 'utils/getValue';
import { urlDelP } from 'utils';
export default {
  namespace: 'cip',
  state: {
    cipInfo: {},
    networkDetail: {}, // cip网络通道详情 airportCode做唯一识别
    cipList: [],
  },
  effects: {
    *getCipInfo({ payload, callback }, { call, put }) {
      const response = yield call(getCipInfo, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            cipInfo: response.data.data,
          },
        });
      }
      callback && callback(response.data.data);
    },
    // cip登录，如果url上没有ciphertext则调用getCipInfo同一个接口，只是判断token返回参数不一样
    *cipLogin({ payload, callback }, { call, put }) {
      try {
        const response = yield call(cipLogin, payload);
        const { redirectUrl = '', netwrokType } = payload;
        if (redirectUrl && redirectUrl.indexOf('search') !== -1 && !netwrokType) {
          payload.netwrokType = 'cip';
        }
        yield put({
          type: 'global/handleAfterLogin',
          payload: response,
          query: payload,
          callback,
        });
      } catch (error) {
        console.log('cipLogin报错', error);
      }
    },
    *getCipNetworkDetail({ payload, callback }, { call, put }) {
      const response = yield call(getCipNetworkDetail, payload);
      const { state, data } = response.data;
      if (state === '11') {
        yield put({
          type: 'setData',
          payload: {
            networkDetail: data,
            cipList: data.list,
          },
        });
        callback && callback(data);
      }
    },
    *getCipFlushQrcode({ payload, callback }, { call, put, select }) {
      try {
        const cipInfo = yield select(({ cip }) => cip.cipInfo);
        const response = yield call(getCipFlushQrcode, payload);
        if (response.data.state === '11') {
          const cip = { ...cipInfo.cip, qrCode: response.data.data.qrCode };
          yield put({
            type: 'setData',
            payload: {
              cipInfo: { ...cipInfo, cip },
            },
          });
          callback && callback(response.data.data);
        }
      } catch (e) {
        console.log(e, 'eeee');
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
